import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import { phonetic_char_list } from './phonetic_char_list'
import EvalScoreUpdateEach from './EvalScoreUpdateEach'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import {
  expand_list_default,
} from '../../../utils/Helper'

// EvalScoreUpdatePart
const EvalScoreUpdatePart = (props) => {

  let [seikaiProcessed, setSeikaiProcessed] = useState('')

  // componentDidMount
  useEffect(() => {

    if ( props.seikaiProcessed ) {
      setSeikaiProcessed(props.seikaiProcessed)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.seikaiProcessed]);


  // create correspondence
  let _create_correspondence =  async ({
    seikaiTexts,
    predictedTexts,
  }) => {

    if (!seikaiTexts) {
      return
    }


    // create expand list
    let _expand_list = expand_list_default
    for (let i=0; i<props.kanakanjiList.length; i++) {
      let _item = props.kanakanjiList[i]
      let _kanji = _item.kanji
      let _kana = _item.kana

      // _expand_list[_kanji] = _kana
      if (!_expand_list[_kanji]) {
        _expand_list[_kanji] = []
      }
      if (_expand_list[_kanji].indexOf(_kana) === -1) {
        _expand_list[_kanji].push(_kana)
      }
    }

    // prepare sentences trim
    let _seikaiTexts = seikaiTexts
    _seikaiTexts = _seikaiTexts.split("、").join(" ")
    _seikaiTexts = _seikaiTexts.split("。").join(" ")
    // _seikaiTexts = _seikaiTexts.split(".").join(" ")
    _seikaiTexts = _seikaiTexts.split("/\s+/").join(" ")
    let seikai_arr = _seikaiTexts.split(" ")


    // remove null items for just in case
    let seikai_arr2 = []
    for ( let i=0; i<seikai_arr.length; i++ ) {
      if (seikai_arr[i]) {
        seikai_arr2.push(seikai_arr[i])
      }
    }
    seikai_arr = seikai_arr2
    _seikaiTexts = seikai_arr.join(" ")

    let _predictedTexts = predictedTexts
    if (!predictedTexts) {
      _predictedTexts = ""
    }
    _predictedTexts = _predictedTexts.split("、").join(" ")
    _predictedTexts = _predictedTexts.split("。").join(" ")
    // _predictedTexts = _predictedTexts.split(".").join(" ")
    _predictedTexts = _predictedTexts.split("/\s+/").join(" ")
    let predicted_arr = _predictedTexts.split(" ")
    // remove null items for just in case
    let predicted_arr2 = []
    for ( let i=0; i<predicted_arr.length; i++ ) {
      if (predicted_arr[i]) {
        predicted_arr2.push(predicted_arr[i])
      }
    }
    predicted_arr = predicted_arr2
    _predictedTexts = predicted_arr.join(" ")

    // sliding function

    let seikai_arr_fin = []
    let prediction_arr_fin = []

    let blocks_4 = _create_blocks_by_window(predicted_arr, seikai_arr, 4, _expand_list)

    // console.log("blocks_4: ", blocks_4)

    for ( let m=0; m<blocks_4.length; m++ ) {

      let _block4 = blocks_4[m]

      if (_block4.type === "match") {
        seikai_arr_fin = seikai_arr_fin.concat(_block4.seikai)
        prediction_arr_fin = prediction_arr_fin.concat(_block4.predicted)
        continue
      }

      // create blocks by sliding window size 3
      let blocks_3 = _create_blocks_by_window(_block4.predicted, _block4.seikai, 3, _expand_list)
      // console.log("blocks_3: ", blocks_3)

      for ( let i=0; i<blocks_3.length; i++ ) {

        let _block3 = blocks_3[i]

        if (_block3.type === "match") {
          seikai_arr_fin = seikai_arr_fin.concat(_block3.seikai)
          prediction_arr_fin = prediction_arr_fin.concat(_block3.predicted)
          continue
        }

        // create blocks by sliding window size 2
        let blocks_2 = _create_blocks_by_window(_block3.predicted, _block3.seikai, 2, _expand_list)
        // console.log("blocks_2: ", blocks_2)

        for (let j=0; j<blocks_2.length; j++) {

          let _block2 = blocks_2[j]
          if (_block2.type === "match") {
            seikai_arr_fin = seikai_arr_fin.concat(_block2.seikai)
            prediction_arr_fin = prediction_arr_fin.concat(_block2.predicted)
            continue
          }

          // console.log("_block2.predicted: ", _block2.predicted)
          // console.log("_block2.seikai: ", _block2.seikai)


          let blocks_1 = _create_blocks_by_window(_block2.predicted, _block2.seikai, 1, _expand_list)
          // console.log("blocks_1: ", blocks_1)

          for ( let k=0; k<blocks_1.length; k++ ) {

            let _block1 = blocks_1[k]

            // サイズが異なる時は　_　で埋める
            if ( _block1.predicted.length > _block1.seikai.length ) {

              let _diff = _block1.predicted.length - _block1.seikai.length
              for (let i=0; i<_diff; i++) {
                _block1.seikai.push("_")
              }

            } else if ( _block1.predicted.length < _block1.seikai.length ) {

              let _diff = _block1.seikai.length - _block1.predicted.length
              // console.log("_diff ", _diff)
              for (let i=0; i<_diff; i++) {
                _block1.predicted.push("_")
              }
            }

            seikai_arr_fin = seikai_arr_fin.concat(_block1.seikai)
            prediction_arr_fin = prediction_arr_fin.concat(_block1.predicted)
          }
        }
      }
    }

    // console.log("--")
    // console.log("seikai: ", seikai_arr_fin)
    // console.log("predic: ", prediction_arr_fin)
    // console.log("--")


    return {
      seikai_arr: seikai_arr_fin,
      prediction_arr: prediction_arr_fin,
    }
  }

  // ['すいません', '三', '点']
  // ['ん', 'です', 'ね', 'そう', 'だっ', 'た', 'ん', 'です', 'ね', 'すいません', '昨年', 'ご', '提案', 'を']
  // >

  // create match and unmatch blocks by sliding window
  let _create_blocks_by_window = (predited_arr, seikai_arr, window_size, _expand_list) => {

    // debug mode ?
    let _debug_mode = false
    // if (seikai_arr.join(" ") === "ね そう し まし たら システム 上 でも") {
    //   _debug_mode = true
    // }
    // if (seikai_arr.join(" ").indexOf("おんけん") !== -1) {
    //   _debug_mode = true
    // }
    // if (seikai_arr.join(" ").indexOf("min") !== -1) {
    //   _debug_mode = true
    // }

    if (_debug_mode === true) {
      console.log("--------------->")
      console.log("seikai_arr: ", seikai_arr.join(" "))
    }

    let seikai_texts = seikai_arr.join(" ")
    let seikai_no_space = seikai_arr.join("")

    let predited_texts = predited_arr.join(" ")

    // 4: ok, 5, ok
    let seikai_meta = {}

    // find out things to combine
    // という 形 でも <=> という 形 で も

    let need_to_combine = []

    let max_i = predited_arr.length+1-window_size

    // generate need to combine...
    // window 3
    for ( let i=0; i<max_i; i++  ) {

      // いい === 良い
      // おっしゃっ === 仰っ
      // いう === 言う
      // やつ === 奴
      // かける === 掛ける
      // かたち === カタチ
      // かたち === 形
      // かたち === 形

      // 正解が漢字、予測がかな
      // 正解がかな、予測が漢字
      let _orig_arr = []
      for ( let j=0; j<window_size; j++ ) {
        _orig_arr.push(predited_arr[i+j])
      }

      let expanded_list = _generateExpandList(_orig_arr, _expand_list)

      if (_debug_mode === true) {
        console.log("expanded_list: ", expanded_list)
      }

      for (let j=0; j<expanded_list.length; j++) {

        //　水増し
        let _expanded = expanded_list[j]

        let predited_chunk3 = ""

        for (let k=0; k<window_size; k++) {
          predited_chunk3 = predited_chunk3+_expanded[k]
        }
        predited_chunk3 = predited_chunk3.trim()

        if ( seikai_no_space.indexOf(predited_chunk3) === -1 ) {
          continue
        }

        let predited_chunk31_orig = ""

        for (let k=0; k<window_size; k++) {
          predited_chunk31_orig = predited_chunk31_orig+" "+predited_arr[i+k]
        }
        predited_chunk31_orig = predited_chunk31_orig.trim()


        let predited_chunk31 = ""

        for (let k=0; k<window_size; k++) {
          predited_chunk31 = predited_chunk31+" "+_expanded[k]
        }
        predited_chunk31 = predited_chunk31.trim()



        // debug / test
        if (_debug_mode === true) {
          console.log("seikai_texts: ", seikai_texts)
          console.log("predited_chunk31_orig: ", predited_chunk31_orig)
        }

        if ( seikai_texts.indexOf(predited_chunk31_orig) === -1) {

          // あくまでオリジナルを入れる必要がある！
          if (need_to_combine.indexOf(predited_chunk31_orig) === -1) {

            // ここは要チェック
            // "頂き <==> いただき"　や　"でも <==> で　も"を同時になんとかしようとしたいので
            // 後者が取れなくなっているかも。
            // if (predited_chunk31_orig !== predited_chunk31) {
              need_to_combine.push({
                exists_in_pred: predited_chunk31_orig,
                found_in_seikai : predited_chunk31
              })
            // }
          }
        }
      }
    }

    // console.log("-- 2 -- ")

    // seikai_texts
    // combine...
    // という 形 でも <=> という 形 で も
    // if (window_size > 1) {
    if (window_size > 0) {

      let seikai_texts2 = seikai_texts
      let predited_texts2 = predited_texts

      for (let i=0; i<need_to_combine.length; i++) {

        let _item = need_to_combine[i]

        let _exists_in_pred = _item.exists_in_pred
        let _found_in_seikai = _item.found_in_seikai

        let _text2 = ""
        for ( let j=0; j<_found_in_seikai.length; j++ ) {
          let _char = _found_in_seikai[j]

          _text2 = _text2 + " " + _char
        }
        _text2 = _text2.trim()
        _text2 = _text2.replace(/\s+/g,' ')

        // if (window_size === 1) {
        //   console.log("_found_in_seikai: ", _found_in_seikai)
        //   console.log("_text2: ", _text2)
        //   console.log("seikai_texts2: ", seikai_texts2)
        // }


        let _text3 = ""
        for ( let j=0; j<_text2.length; j++ ) {
          let _char = _text2[j]
          if (_char === " ") {
            _text3 = _text3 + _char + "?"
          } else {
            _text3 = _text3 + _char
          }
        }
        _text3 = _text3.trim()

        //
        let position_type = "normal"
        if (seikai_texts2 === _found_in_seikai) {
          // exact same
          // _text3 = _text3

          // console.log("_found_in_seikai 1")
          position_type = "exact"

        } else if (seikai_texts2.startsWith(_found_in_seikai) === true) {
          _text3 = _text3 + " "

          // console.log("_found_in_seikai 2")
          position_type = "start"

        } else if (seikai_texts2.endsWith(_found_in_seikai) === true) {
          _text3 = " " +_text3
          position_type = "end"
          // console.log("_found_in_seikai 3")

        } else {
          _text3 = " " +_text3 + " "
          position_type = "normal"

          // console.log("_found_in_seikai 4")
        }

        let _re3 = new RegExp(_text3)

        // if (window_size === 1) {
        //
        //   console.log("$$$$$")
        //   console.log("_text3: ", _text3)
        //   console.log("seikai_texts2: ", seikai_texts2)
        //
        //   console.log("_exists_in_pred: ", _exists_in_pred)
        //   console.log("$$$$$")
        // }


        let _match = seikai_texts2.match(_re3)
        if (_match) {

          // 正解が変わってしまうのはマズイ
          // seikai_texts2 = seikai_texts2.split(_match[0]).join(" "+_exists_in_pred+" ")

          let _exists_in_pred_2 = ""
          if (position_type === "exact") {
            _exists_in_pred_2 = _exists_in_pred
          } else if (position_type === "start") {
            _exists_in_pred_2 = _exists_in_pred + " "
          } else if (position_type === "end") {
            _exists_in_pred_2 = " " + _exists_in_pred
          } else {
            _exists_in_pred_2 = " " + _exists_in_pred + " "
          }

          predited_texts2 = predited_texts2.split(_exists_in_pred_2).join(_match[0])


          // if (window_size === 1) {
          //
          //   console.log("$$$$$$$$")
          //   console.log("_text3: ", _text3)
          //   console.log("seikai_texts2: ", seikai_texts2)
          //
          //   console.log("_match[0]: ", _match[0], ", _exists_in_pred: ", _exists_in_pred)
          //   console.log("$$$$$$$$")
          //
          //   console.log("predited_texts2: ", predited_texts2, _exists_in_pred_2)
          // }

        }
      }
      // インデックスを取得する
      seikai_texts = seikai_texts2
      predited_texts = predited_texts2
    }

    predited_arr = predited_texts.split(" ")
    seikai_arr = seikai_texts.split(" ")

    // if (_debug_mode === true) {
    //   console.log("seikai_arr new :", seikai_arr)
    // }

    // console.log("-- 3 -- ")

    let last_bb_arr_idx = -1
    let max_seikai_index = -1

    // ここまでで、window 比較をするための下拵え（漢字の調整、単語分割数のゆらぎなどを調整している）
    // based on window 3
    for ( let i=0; i<max_i; i++ ) {

      let predited_chunk3 = ""

      // console.log("-- 3.1 -- ")

      for (let k=0; k<window_size; k++) {
        predited_chunk3 = predited_chunk3+predited_arr[i+k]
      }
      predited_chunk3 = predited_chunk3.trim()

      if ( seikai_no_space.indexOf(predited_chunk3) === -1 ) {
        continue
      }

      // console.log("-- 3.2 -- ")

      let predited_chunk31 = ""

      for (let k=0; k<window_size; k++) {
        predited_chunk31 = predited_chunk31+" "+predited_arr[i+k]
      }
      predited_chunk31 = predited_chunk31.trim()


      // // debug / test
      // if (_debug_mode === true) {
      //   console.log("")
      //   console.log("predited_chunk31: ", "|"+predited_chunk31+"|")
      //   console.log("")
      // }

      // if predited_chunk31 is "", then continue
      if (!predited_chunk31) {
        continue
      }

      let predited_chunk312 = predited_chunk31
      if (seikai_texts === predited_chunk31) {
        // exact same
        predited_chunk312 = predited_chunk31

      } else if (seikai_texts.startsWith(predited_chunk31) === true) {
        // detected from start
        predited_chunk312 = predited_chunk312 + " "
      } else if (seikai_texts.endsWith(predited_chunk31) === true) {
        predited_chunk312 = " " + predited_chunk312
      } else {
        predited_chunk312 = " " + predited_chunk31 + " "
      }


      // // debug / test
      // if (_debug_mode === true) {
      //   console.log("")
      //   console.log("predited_chunk312: ", "|"+predited_chunk312+"|")
      //   console.log("")
      // }


      // 文章が長いと遠くで見つかる場合がある！！！
      // if ( predited_chunk31 && seikai_texts.indexOf(" "+predited_chunk31+" ") !== -1) {
      if ( seikai_texts.indexOf(predited_chunk312) !== -1) {

        // // debug / test
        // if (_debug_mode === true) {
        //   console.log("")
        //   console.log("seikai_texts: ", seikai_texts)
        //   console.log("predited_chunk312: ", "|"+predited_chunk312+"|")
        //   console.log("")
        // }


        let _indexes = getAllIndexes(seikai_texts, predited_chunk31);

        // console.log("-- 3.3.1 -- ", _indexes)

        // 正解テキストの中で予測チャンクが出てくる場所を突き止める
        let _idx = -1
        for ( let j=0; j<_indexes.length; j++ ) {
          if (_indexes[j] > last_bb_arr_idx) {
            _idx = _indexes[j]
            break
          }
        }

        // console.log("-- 3.3.2 -- _idx: ", _idx, ", last_bb_arr_idx: ", last_bb_arr_idx)

        // 遠くで見つかった場合はどうする？
        // predited_chunk31が　ひらがなオンリーの場合は...

        let _diff333 = _idx - last_bb_arr_idx
        // console.log("_diff333: ", _diff333)

        // console.log("predited_chunk31: ", predited_chunk31 )

        // 8 is just a hardcoded number
        // it's something called huristic
        let predited_chunk31_nospace = predited_chunk31.split(" ").join("")
        if ( _check_if_hiragana_only(predited_chunk31_nospace) === true && _diff333 > 8 ) {
          if (last_bb_arr_idx !== -1) {
            // console.log("predited_chunk31: ", predited_chunk31, _idx, _diff333 )
            continue
          }
        }


        // 予測チャンクのテキストと同じ？
        let _aaa =  seikai_texts.substr(_idx, predited_chunk31.length)
        // console.log("-- 3.3.2.1 -- _aaa: ", _aaa, ", ", predited_chunk31)

        // 前の部分
        let _bbb =  seikai_texts.substr( 0, _idx)
        // console.log("-- 3.3.2.2 -- _bbb: ", _bbb)

        _bbb = _bbb.trim()
        // console.log("-- 3.3.2.3 -- _bbb: ", _bbb)

        let _bb_arr =  _bbb.split(" ")

        // console.log("-- 3.3.3 -- _bb_arr: ", _bb_arr)

        // スペースで分解した時のインデックスを取る
        let _seikai_idx = 0
        if (_bbb){
          _seikai_idx = _bbb.split(" ").length
        }

        // console.log("-- 3.4 -- _seikai_idx: ", _seikai_idx)

        last_bb_arr_idx = _idx

        if (_seikai_idx < max_seikai_index) {
          continue
        }

        for (let k=0; k<window_size; k++) {

          let _word = seikai_arr[_seikai_idx+k]

          // console.log("_word: ", _word, ", _seikai_idx: ", _seikai_idx, ", k: ", k, ", pred_idx: ", i+k, i)
          // console.log("predited_arr: ", predited_arr)

          // console.log("_word:",  _word, _seikai_idx+k, i+k)

          let _predicted_word = predited_arr[i+k]
          if (_word !== _predicted_word) {
            continue
          }

          // // debug / test
          // if (_debug_mode === true) {
          //   console.log("")
          //   console.log("add to seikai_meta: ")
          //   console.log("word: ", _word)
          //   console.log("seikai_idx: ", _seikai_idx+k)
          //   console.log("pred_idx: ", i+k)
          //   console.log("")
          // }


          if (!seikai_meta[_seikai_idx+k]) {

            seikai_meta[_seikai_idx+k] = {
              'word': _word,
              'seikai_idx': _seikai_idx+k,
              'pred_idx': i+k,
            }
            max_seikai_index = _seikai_idx+k
          }
        }
      }
    }

    // debug / test
    if (_debug_mode === true) {
      console.log("")
      console.log("seikai_meta: ", seikai_meta)
      console.log("seikai_arr: ", seikai_arr)
      console.log("predited_arr: ", predited_arr)
      console.log("")
    }



    // console.log("-- 4 -- ")

    // // もし先頭が既にずれている時は no_match を先にいれてしまうのはどうだ？
    // // debug / test
    // if (window_size === 1) {
    //   for ( let key in seikai_meta ) {
    //     let item = seikai_meta[key]
    //     console.log("")
    //     console.log("seikai_meta: ", seikai_meta, key)
    //     console.log("item: ", item)
    //     console.log("")
    //   }
    // }


    // どうしても「フォマート の」と「フォマ の」がマッチしていることになっていまう。

    let arr_blocks = [{
      type: 'match',
      predicted: [],
      seikai: [],
    }]

    // マッチしている部分、マッチしていない部分を取得する
    // 2, 7 ,21 >
    let last_key = -1
    let last_continuous_key = -1
    for ( let key in seikai_meta ) {

      let item = seikai_meta[key]

      key = parseInt(key)

      if (last_key === key - 1) {

        last_continuous_key = key

      } else {

        let _pred_idx_start = 0
        let _seikai_idx_start = 0
        if (last_continuous_key > -1) {

          let item2 = seikai_meta[last_continuous_key]
          _pred_idx_start = item2.pred_idx + 1
          _seikai_idx_start = item2.seikai_idx + 1
        }

        let _pred_idx_end = item.pred_idx - 1
        let _seikai_idx_end = item.seikai_idx -1

        let _predicted = ""
        let _predicted_min_arr = []


        for ( let i=_pred_idx_start; i<_pred_idx_end+1; i++ ) {

          _predicted = _predicted + " " + predited_arr[i]
          _predicted_min_arr.push(predited_arr[i])
        }
        _predicted = _predicted.trim()

        let _seikai = ""
        let _seikai_min_arr = []
        for ( let i=_seikai_idx_start; i<_seikai_idx_end+1; i++ ) {
          _seikai = _seikai + " " + seikai_arr[i]

          _seikai_min_arr.push(seikai_arr[i])
        }
        _seikai = _seikai.trim()

        arr_blocks.push({
          type: 'not_match',
          predicted: _predicted_min_arr,
          seikai: _seikai_min_arr,
        })

        // debug / test
        if (_debug_mode === true) {
          console.log("-- 2 -- not_match ", last_continuous_key)
          console.log(_predicted_min_arr)
          console.log(_seikai_min_arr)
        }

        // push next
        arr_blocks.push({
          type: 'match',
          predicted: [],
          seikai: [],
        })

        last_continuous_key = key
      }

      let last_idx = arr_blocks.length - 1

      // if (_debug_mode === true) {
      //   console.log("-- 1 -- match ", last_continuous_key)
      //   console.log(predited_arr[item.pred_idx], item.pred_idx)
      //   console.log(seikai_arr[item.seikai_idx], item.seikai_idx)
      // }

      arr_blocks[last_idx].predicted.push(predited_arr[item.pred_idx])
      arr_blocks[last_idx].seikai.push(seikai_arr[item.seikai_idx])

      // // debug / test
      // if (window_size === 1) {
      //   console.log("")
      //
      //   console.log("")
      //   console.log("seikai_meta: ", seikai_meta)
      //   console.log("")
      //
      //   console.log("predited_arr[item.pred_idx]: ", predited_arr[item.pred_idx])
      //   console.log("seikai_arr[item.seikai_idx]: ", seikai_arr[item.seikai_idx])
      //   console.log(arr_blocks[last_idx])
      //   console.log("last_idx: ", last_idx)
      //   console.log("")
      // }

      // post process
      last_key = key
    }

    // console.log("-- 5 -- ")

    // 最後のマッチしていない部分を付け足す

    let last_item = seikai_meta[last_key]
    let last_pred_idx = 0
    let last_seikai_idx = 0
    if (last_item) {
      last_pred_idx = last_item.pred_idx+1
      last_seikai_idx = last_item.seikai_idx+1
    }

    let _predicted_min_arr = predited_arr.slice(last_pred_idx, predited_arr.length)
    let _seikai_min_arr = seikai_arr.slice(last_seikai_idx, seikai_arr.length)

    arr_blocks.push({
      type: 'not_match',
      predicted: _predicted_min_arr,
      seikai: _seikai_min_arr,
    })

    let arr_blocks2 = []
    for ( let i=0; i<arr_blocks.length; i++ ) {
      let arr_block = arr_blocks[i]

      if (arr_block.predicted.length === 0 && arr_block.seikai.length === 0) {
        continue
      }
      arr_blocks2.push(arr_block)
    }
    arr_blocks = arr_blocks2

    // console.log("<---------------")

    if (_debug_mode === true) {
      console.log("-- 6 -- arr_blocks:", arr_blocks)
      console.log("<---------------")
    }

    return arr_blocks
  }


  // 配列を受け取って、可能性のるリストに水増しする
  // いい === 良い
  // おっしゃっ === 仰っ
  // いう === 言う
  // やつ === 奴
  // かける === 掛ける
  // かたち === カタチ
  // かたち === 形
  let _generateExpandList = ( list1, list3 ) => {

    let arr_count = 1

    for ( let i=0; i<list1.length; i++ ) {

      let _word = list1[i]

      if (list3[_word]) {
        let _similar_count = list3[_word].length
        arr_count = arr_count * (_similar_count + 1)
      }
    }

    // create empty arrays
    let return_arr1 = []
    for ( let i=0; i<arr_count; i++ ) {
      return_arr1.push([])
    }

    for ( let i=0; i<return_arr1.length; i++ ) {

      for ( let j=0; j<list1.length; j++ ) {

        let _word = list1[j]

        let _list4 = [_word]

        let _count = 1

        if (list3[_word]) {

          for ( let k=0; k<list3[_word].length; k++ ) {

            let _tmp1 = list3[_word][k]
            if (_list4.indexOf(_tmp1) === -1 ) {
              _list4.push(_tmp1)
            }
          }
        }

        // ここまでで["今後", "こんご"]ができてる

        let _tmp_index = i % _list4.length

        return_arr1[i].push(_list4[_tmp_index])
      }

    }

    return return_arr1
  }










  // get word dict come out
  let _get_words_come_out = (_texts, _kanji_flg) => {

    let _arr = _texts.split(" ")

    let _dict = {}

    for ( let i=0; i<_arr.length; i++ ) {

      let _word = _arr[i]
      if (_kanji_flg === true) {
        if ( _word.length > 3 || _check_if_hiragana_only(_word) === false ) {
          if (!_dict[_word]) {
            _dict[_word] = 0
          }
          _dict[_word] = _dict[_word] + 1
        }
      } else {
        if ( _word.length > 0 ) {
          if (!_dict[_word]) {
            _dict[_word] = 0
          }
          _dict[_word] = _dict[_word] + 1
        }
      }
    }
    return _dict
  }

  // _get_word_overlap
  let _get_word_overlap = (word_dict1, word_dict2) => {

    let _dict = {}

    for ( let word in word_dict1) {
      let count = word_dict1[word]
      if ( word_dict1[word] === word_dict2[word] ) {
        _dict[word] = word_dict1[word]
      }
    }

    return _dict
  }

  // check indexes of overlapped words
  let _check_indexes_of_overlap_words = (word_dict, texts1, texts2) => {


    let compare = ( a, b ) => {
      if ( a.index < b.index ){
        return -1;
      }
      if ( a.index > b.index ){
        return 1;
      }
      return 0;
    }

    let _arr1 = texts1.split(" ")
    let _arr2 = texts2.split(" ")

    let _arr3 = []
    for (let word in word_dict) {
      let _indexes = getAllIndexes(_arr1, word)
      for ( let i=0; i<_indexes.length; i++ ) {
        _arr3.push({
          word: word,
          index: _indexes[i]
        })
      }
    }
    _arr3 = _arr3.sort(compare)


    let _arr4 = []
    for (let word in word_dict) {
      let _indexes = getAllIndexes(_arr2, word)
      for ( let i=0; i<_indexes.length; i++ ) {
        _arr4.push({
          word: word,
          index: _indexes[i]
        })
      }
    }
    _arr4 = _arr4.sort(compare)

    let _arr5 = []
    for ( let i=0; i<_arr3.length; i++ ) {
      let word1 = _arr3[i].word
      let word2 = _arr4[i].word
      if (word1 === word2) {
        _arr5.push(word1)
      }
    }
    return _arr5
  }


  // create comparison table
  let _create_comparison_table = (_seikaiTexts, _shabelabTexts, come_out_in_both_words, recursive_flg) => {

    let _found_words_1 = come_out_in_both_words

    let seikai_arr = _seikaiTexts.split(" ")

    let _after_part_seikai = _seikaiTexts
    let _after_part_prediction = _shabelabTexts
    // let _start_idx = 0

    let _before_part_seikai_all_arr = []
    let _before_part_prediction_all_arr = []

    // sample word
    for ( let i=0; i<_found_words_1.length; i++ ) {

      let _match_kanji = _found_words_1[i]
      let _re = new RegExp(_match_kanji+'(.+)');

      // before 来年 of seikai
      _after_part_seikai = " "+_after_part_seikai+" "
      let _before_part_seikai = _after_part_seikai.split(_re)[0].trim()
      if ( _after_part_seikai.split(_re).length > 1 ) {
        _after_part_seikai =  _after_part_seikai.split(_re)[1].trim()
      } else {
        _after_part_seikai = ""
      }

      // before 来年 of prediction
      _after_part_prediction = " "+_after_part_prediction+" "
      let _before_part_prediction = _after_part_prediction.split(_re)[0].trim()
      if ( _after_part_prediction.split(_re).length > 1 ) {
        _after_part_prediction = _after_part_prediction.split(_re)[1].trim()
      } else {
        _after_part_prediction = ""
      }

      //
      let _before_part_seikai_arr = _before_part_seikai.split(" ")
      //
      let _before_part_prediction_arr = _before_part_prediction.split(" ")

      if ( _before_part_seikai_arr.length > _before_part_prediction_arr.length ) {
        let _diff = _before_part_seikai_arr.length - _before_part_prediction_arr.length
        for ( let j=0; j<_diff; j++ ) {
          _before_part_prediction_arr.splice(0, 0, "_");
          // _before_part_prediction_arr.push("_")
        }

      } else if ( _before_part_seikai_arr.length < _before_part_prediction_arr.length ) {
        let _diff = _before_part_prediction_arr.length - _before_part_seikai_arr.length
        for ( let j=0; j<_diff; j++ ) {
          _before_part_seikai_arr.splice(0, 0, "_");
          // _before_part_seikai_arr.push("_")
        }
      }

      // if recursive_flg is true, do it once more...
      if (recursive_flg === true) {

        // tmp
        let matched_indexes_tmp = []
        for (let j=0; j<_before_part_seikai_arr.length; j++) {
          let _seikai = _before_part_seikai_arr[j]
          let _prediction = _before_part_prediction_arr[j]
          if ( _seikai !== "_" && _seikai === _prediction ) {
            matched_indexes_tmp.push(j)
          }
        }

        // get parts not arranged
        let not_arrigned_indexes = []
        let not_arrigned_indexes_tmp = []
        for (let j=0; j<_before_part_seikai_arr.length; j++) {

          let _seikai = _before_part_seikai_arr[j]
          let _pred = _before_part_prediction_arr[j]

          if ( matched_indexes_tmp.indexOf(j) !== -1 ) {
            if ( not_arrigned_indexes_tmp.length > 1 ) {
              not_arrigned_indexes.push(not_arrigned_indexes_tmp)
              not_arrigned_indexes_tmp = []
            }
          } else {
            not_arrigned_indexes_tmp.push(j)
          }
        }
        not_arrigned_indexes.push(not_arrigned_indexes_tmp)
        not_arrigned_indexes_tmp = []

        if (not_arrigned_indexes.length > 0 && not_arrigned_indexes[0] !== "") {

          let _before_part_seikai_arr2 = []
          let _before_part_prediction_arr2 = []
          for ( let j=0; j<not_arrigned_indexes.length; j++ ) {

            let _parts_need_to_analyze = not_arrigned_indexes[j]
            let _parts_seikai = ""
            let _parts_prediction = ""
            for ( let k=0; k<_parts_need_to_analyze.length; k++ ) {
              let _idx = _parts_need_to_analyze[k]
              if ( _before_part_seikai_arr[_idx] !== "_" ) {
                _parts_seikai = _parts_seikai + " " + _before_part_seikai_arr[_idx]
              }
              if ( _before_part_prediction_arr[_idx] !== "_" ) {
                _parts_prediction = _parts_prediction + " " + _before_part_prediction_arr[_idx]
              }
            }
            _parts_seikai = _parts_seikai.trim()
            _parts_prediction = _parts_prediction.trim()


            // get kanji words on seikai
            let words_seikai = _get_words_come_out(_parts_seikai, false)

            // get kanji words on prediction
            let words_pred = _get_words_come_out(_parts_prediction, false)

            // get overlapping words
            let words_overlap = _get_word_overlap(words_seikai, words_pred)

            let _word_list = _check_indexes_of_overlap_words(words_overlap, _parts_seikai, _parts_prediction)

            let _results = _create_comparison_table(_parts_seikai, _parts_prediction, _word_list, false)

            // add first parts if matched index not starting from 0

            let _last_idx = _parts_need_to_analyze[_parts_need_to_analyze.length-1]

            if ( j === 0 && _parts_need_to_analyze[0] !== 0) {

              _before_part_seikai_arr2 = _before_part_seikai_arr2.concat(_before_part_seikai_arr.slice(0, _last_idx))
              _before_part_prediction_arr2 = _before_part_prediction_arr2.concat(_before_part_prediction_arr.slice(0, _last_idx))
            }

            // add adjusted parts and already matched parts

            _before_part_seikai_arr2 = _before_part_seikai_arr2.concat(_results.seikai_arr)
            _before_part_prediction_arr2 = _before_part_prediction_arr2.concat(_results.prediction_arr)

            // let _last_idx = _parts_need_to_analyze[_parts_need_to_analyze.length-1]
            if (j !== not_arrigned_indexes.length - 1) {
              let _next_idx = not_arrigned_indexes[j+1][0]

              _before_part_seikai_arr2 = _before_part_seikai_arr2.concat(_before_part_seikai_arr.slice(_last_idx+1, _next_idx))
              _before_part_prediction_arr2 = _before_part_prediction_arr2.concat(_before_part_prediction_arr.slice(_last_idx+1, _next_idx))
            } else {
              // sometimes _last_idx is undefined
              if (_last_idx) {

                _before_part_seikai_arr2 = _before_part_seikai_arr2.concat(_before_part_seikai_arr.slice(_last_idx+1))
                _before_part_prediction_arr2 = _before_part_prediction_arr2.concat(_before_part_prediction_arr.slice(_last_idx+1))
              }
            }

          }
          _before_part_seikai_arr = _before_part_seikai_arr2
          _before_part_prediction_arr = _before_part_prediction_arr2
        }
      }

      // final seikai array
      if (_before_part_seikai_arr.length > 0 && _before_part_seikai_arr[0] !== "") {
        _before_part_seikai_all_arr = _before_part_seikai_all_arr.concat(_before_part_seikai_arr)
      } else {
        // _before_part_seikai_all_arr = _before_part_seikai_all_arr.concat(["_"])
      }
      _before_part_seikai_all_arr = _before_part_seikai_all_arr.concat([_match_kanji])

      // final seikai array
      if (_before_part_prediction_arr.length > 0 && _before_part_seikai_arr[0] !== "") {
        _before_part_prediction_all_arr = _before_part_prediction_all_arr.concat(_before_part_prediction_arr)
      } else {
        // _before_part_prediction_all_arr = _before_part_prediction_all_arr.concat(["_"])
      }
      _before_part_prediction_all_arr = _before_part_prediction_all_arr.concat([_match_kanji])

      // _start_idx = _start_idx + _before_part_seikai_arr.length + 1

    }

    // add last parts
    let _after_part_seikai_arr = _after_part_seikai.split(" ")
    let _after_part_prediction_arr = _after_part_prediction.split(" ")

    if (_after_part_seikai_arr[0] === "") {
      _after_part_seikai_arr = []
    }
    if (_after_part_prediction_arr[0] === "") {
      _after_part_prediction_arr = []
    }

    if ( _after_part_seikai_arr.length > _after_part_prediction_arr.length ) {

      let _diff = _after_part_seikai_arr.length - _after_part_prediction_arr.length
      for ( let j=0; j<_diff; j++ ) {
        _after_part_prediction_arr.splice(0, 0, "_");
        // _after_part_prediction_arr.push("_")
      }

    } else if ( _after_part_seikai_arr.length < _after_part_prediction_arr.length ) {

      let _diff = _after_part_prediction_arr.length - _after_part_seikai_arr.length
      for ( let j=0; j<_diff; j++ ) {
        _after_part_seikai_arr.splice(0, 0, "_");
        // _after_part_seikai_arr.push("_")
      }
    }

    _before_part_seikai_all_arr = _before_part_seikai_all_arr.concat(_after_part_seikai_arr)
    _before_part_prediction_all_arr = _before_part_prediction_all_arr.concat(_after_part_prediction_arr)

    return {
      // matched_indexes: ok_indexes_seikai,
      seikai_arr: _before_part_seikai_all_arr,
      prediction_arr: _before_part_prediction_all_arr
    }
  }

  // check if kana exists
  let _check_if_hiragana_only = (data_str) => {

    let hiraganaonly = true
    for (let i=0; i<data_str.length; i++){
      const word1 = data_str[i]
      if ( phonetic_char_list.indexOf(word1) === -1) {
        hiraganaonly = false
        break
      }
    }

    return hiraganaonly
  }

  // get indexes ...
  let getAllIndexes = (arr, val) => {
    var indexes = [], i = -1;
    while ((i = arr.indexOf(val, i+1)) != -1){
        indexes.push(i);
    }
    return indexes;
  }

  return (

    <DndProvider backend={HTML5Backend}>

      <div>

        {/* loop */}
        {props.engineList.map((item, idx) => (
          <EvalScoreUpdateEach
            saveChunkWer={props.saveChunkWer}
            accountType={props.accountType}
            item={item}
            key={item._id+idx}
            name={item._id+idx}
            deleteSavedPairList={props.deleteSavedPairList}
            savePredictionAndWer={props.savePredictionAndWer}
            create_correspondence={_create_correspondence}
            kanakanjiList={props.kanakanjiList}
            seikaiProcessed={seikaiProcessed} />
        ))}

      </div>

    </DndProvider>
  )
}

export default EvalScoreUpdatePart
